$shm_codex_app $shm_agent_app
	agent_defaults_namespace \codex
